import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/config';
export function GuaranteeSection() {
  return <section className="bg-slate-50 px-4 py-7 md:px-12" data-id="element-72" data-mp="4vjmq3szb4em">
      <div className="flex gap-3 rounded-md border border-amber-400 bg-white p-4" data-id="element-73" data-mp="9u3925bhii7i">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-amber-500" strokeWidth={1.75} aria-hidden data-id="element-74" data-mp="etz3bcudqv9v" />
        <div data-id="element-75" data-mp="jt29j0m3j7jf">
          <h2 className="text-lg font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-xl" data-id="element-76" data-mp="jtbxyjrht6n0">
            Tu compra está protegida
          </h2>
          <p className="mt-0.5 text-xs font-extrabold uppercase text-sky-600 md:text-sm" data-id="element-77" data-mp="skudqtkj1kfk">
            Tenés 7 días para conocer el sistema.
          </p>
          <div className="mt-1.5 space-y-1.5 text-sm leading-snug text-slate-600 md:text-base" data-id="element-78" data-mp="xjfh31v2sk88">
            <p data-id="element-79" data-mp="12kbmxkyzmgga">
              Explorá el <strong className="text-blue-950" data-id="element-80" data-mp="12gxjsaii237s">COMBO COMPLETO ELECTRICISTAS</strong>, sus cuatro tomos
              principales y los cuatro bonos profesionales.
            </p>
            <p data-id="element-81" data-mp="25ti3mcw1ccwu">
              Consultá los casos de diagnóstico, los diagramas, los ejemplos de mediciones y las herramientas incluidas.
              Queremos que encuentres un material práctico y útil para tu actividad.
            </p>
            <p data-id="element-82" data-mp="1rs5qsac68rf6">
              Si el producto no se ajusta a tus necesidades, podés comunicarte dentro del plazo de 7 días para solicitar
              la revisión de tu compra y el reembolso conforme a las condiciones de garantía publicadas.
            </p>
          </div>
          <p className="mt-2 text-sm font-bold text-blue-950" data-id="element-83" data-mp="2jleteaa8eaq2">
            Correo de soporte:{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-sky-600 underline" data-id="element-84" data-mp="2eqio48fzhqv0">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>
      </div>
    </section>;
}